// components
import { U21TimelineEntry } from 'app/shared/u21-ui/components';

// types
import { AuditServiceEntry } from 'app/modules/auditService/types';
import {
  AUDIT_TRAIL_ACTION_TO_CONTENT,
  ImpersonatingContext,
} from 'app/modules/auditService/constants/auditTrailStrings';

interface Props extends AuditServiceEntry {}

export const AuditTrailEntry = ({
  action,
  actor,
  asset,
  details,
  createdAt,
  isImpersonating,
}: Props) => {
  const Content = AUDIT_TRAIL_ACTION_TO_CONTENT[action];
  const isViewDetail = action.endsWith('.view_detail');
  return Content ? (
    <U21TimelineEntry
      color={isViewDetail ? 'default' : 'info'}
      timestamp={createdAt}
    >
      <ImpersonatingContext.Provider value={isImpersonating ?? false}>
        <Content actor={actor} asset={asset} details={details} />
      </ImpersonatingContext.Provider>
    </U21TimelineEntry>
  ) : null;
};
